import { IMultiSuggestResult } from '@cian/geosuggest-widget';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { ETargetPage } from '../../types/page';
import { IThunkApi } from '../../types/redux';

import { FLATS_NOT_FOUND_ERROR, SERVER_ERROR } from '../../constants/geosuggestErrorMessages';
import { setAddressGeoSuggestFailure, setAddressGeoSuggestRequest, setAddressGeoSuggestSuccess } from '../../slices';
import { getMultiSuggest } from '../../utils/getMultiSuggest';

interface IParams {
  addressChunk: string;
  targetPage: ETargetPage;
}

const processResponse = (res: IMultiSuggestResult) => {
  const suggestLength = res.suggestions.addresses?.length;

  if (suggestLength) {
    return setAddressGeoSuggestSuccess(res);
  }

  return setAddressGeoSuggestFailure(FLATS_NOT_FOUND_ERROR);
};

export const getFlatGeoSuggest = createAsyncThunk<void, IParams, IThunkApi>(
  'getFlatGeoSuggest',
  async ({ addressChunk, targetPage }, _thunkApi) => {
    const {
      extra: { logger, config },
      dispatch,
    } = _thunkApi;

    dispatch(setAddressGeoSuggestRequest());

    const apiKey = config.get<string>('valuation.YandexApiKey');
    const suggestApiKey = config.get<string>('valuation.YandexSuggestApiKey');

    if (apiKey && suggestApiKey) {
      try {
        const suggestResult: IMultiSuggestResult = await getMultiSuggest({
          yandex: { value: addressChunk.trim(), apiKey, suggestApiKey },
          targetPage,
        });

        const action = processResponse(suggestResult);
        dispatch(action);
      } catch (e) {
        dispatch(setAddressGeoSuggestFailure(SERVER_ERROR));
      }
    } else {
      logger.error('Failed get valuation.YandexApiKey or valuation.YandexSuggestApiKey. Suggest not working.', {
        domain: 'frontend-valuation-form__getFlatGeoSuggest',
      });
      dispatch(setAddressGeoSuggestFailure(SERVER_ERROR));
    }
  },
);
